const URL_PATHS = {
  profile: {
    root: 'profile',
  },
  business_hours: {
    root: 'business_hours',
  },
  service_area: {
    root: 'service_area',
  },
  employees: {
    root: 'employees',
    bulk_edit: 'employees/bulk_edit',
    new: 'employees/new',
    my_account: 'employees/my_account',
    skip_new: 'employees/skip/new',
    first_time_use: 'employees/first_time_use',
    archived: 'employees/archived',
    labor_cost: 'employees/labor_costs',
  },
  billing: {
    root: 'billing',
  },
  text_messages: {
    root: 'text_messages',
  },
  customer_intake: {
    root: 'intake/settings',
    reminders: 'intake/settings/reminders',
    faq: 'intake/settings/faq',
    requestGuide: 'intake/settings/request_guide',
    requestGuideWizard: 'intake/request_guide_wizard/industries',
  },
  online_booking: {
    root: 'online_booking/settings',
    available_services: 'online_booking/settings/available_services',
    online_booking_hours: 'online_booking/settings/online_booking_hours',
    available_employees: 'online_booking/settings/available_employees',
    preview: 'online_booking/settings/preview',
    share_booking_page: 'online_booking/settings/share_booking_page',
  },
  voice: {
    root: 'voice',
    onboarding: 'voice/onboarding',
    phone_numbers: 'voice/phone_numbers',
    call_flows: 'voice/call_flows',
    audio_library: 'voice/audio_library',
    ring_groups: 'voice/ring_groups',
    recording_calls: 'voice/recording_calls',
    masking_calls: 'voice/masking_calls',
    plan_usage: 'voice/plan_usage',
  },
  hcp_assist: {
    root: 'hcp_assist',
    plan_usage: 'hcp_assist/plan_usage',
  },
  pricebook: {
    root: 'pricebook',
  },
  service_plans: {
    root: 'service_plans',
  },
  job_details: {
    root: 'job_details',
    job_fields: 'job_details/job_fields',
    job_costing: 'job_details/job_costing',
    job_line_item_details: 'job_details/job_line_item_details',
    material_details: 'job_details/material_detail_tracking',
    signatures: 'job_details/signatures',
    commissions: 'job_details/commissions',
  },
  invoices: {
    root: 'default_invoice_settings',
    customer_view: 'default_invoice_settings/customer_view',
    email_and_sms: 'default_invoice_settings/email_and_sms',
    payment_options: 'default_invoice_settings/payment_options',
    automatic_reminders: 'default_invoice_settings/automatic_reminders',
  },
  estimates: {
    root: 'default_estimate_settings',
    customer_view: 'default_estimate_settings/customer_view',
    email_and_sms: 'default_estimate_settings/email_and_sms',
    expiration_date: 'default_estimate_settings/expiration_date',
  },
  pipeline: {
    root: 'pipeline',
    automations: 'pipeline/automations',
    customize_boards: 'pipeline/customize_boards',
    intro_page: 'pipeline/intro_page',
  },
  time_tracking: {
    root: 'time_tracking',
  },
  tags: {
    root: 'tags',
  },
  lead_source: {
    root: 'lead_source',
  },
  quickbooks_online: {
    root: 'quickbooks_online',
    sync_alerts: 'quickbooks_online/sync_alerts',
    import: 'quickbooks_online/import',
    banking: 'quickbooks_online/banking',
    account_details: 'quickbooks_online/account_details',
  },
};

export default URL_PATHS;
